
export const GetAllUsersAutocomplete = async (page = 1, limit = 10) => {
  const API_URL = process.env.REACT_APP_API_URL + "user/";
  try {
    const response = await fetch(
      `${API_URL}?page=${page}&limit=${limit}` 
    );

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      status: response.status,
      data: data.response?.data || data  
    };
  } catch (error) {
    console.error("[GetAllUsersAutocomplete] Error:", error);
    
    return {
      data: [],
      status: error.response?.status || 500  
    };
  }
};




export const GetAllPackegesAutocomplete = async (page = 1, limit = 10) => {
  const API_URL = process.env.REACT_APP_API_URL +  "package/";
  try {
    const response = await fetch(
      `${API_URL}?page=${page}&limit=${limit}`  
    );

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      status: response.status,
      data: data.response?.data || data  
    };
  } catch (error) {
    console.error("[GetAllUsersAutocomplete] Error:", error);
    
    return {
      data: [],
      status: error.response?.status || 500  
    };
  }
};




export const GetAllReservationsByDateApi = async ({ 
  page = 1, 
  limit = Number.MAX_SAFE_INTEGER,
  dateOfReservation ="" ,
  isPaid=true
}) => {
  const API_URL = process.env.REACT_APP_API_URL + "reservations/";
  try {

    const response = await fetch(
      `${API_URL}?page=${page}&limit=${limit}&dateOfReservation=${dateOfReservation}&isPaid=${isPaid}`
    );

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      status: response.status,
      data: data.response?.data || data  
    };
  } catch (error) {
    console.error("[GetReservationsByDate] Error:", error);
    
    return {
      data: [],
      status: error.response?.status || 500  
    };
  }
};


